import { Delivery, DeliveryOrder } from '../../../state/types'
import { useEffect, useState } from 'react'
import { useDeliveryLoaders } from '../../../loaders/deliveryLoaders'
import { DownloadDeliveryNotesModal } from '../../delivery/download-delivery-notes-modal/downloadDeliveryNotesModal'
import { toList } from '../../../../../utils/listUtils'

type Props = {
    deliveryOrder?: DeliveryOrder
}

export const DownloadDeliveryOrderNotesModal = (props: Props) => {
    const { deliveryOrder } = props

    const [deliveries, setDeliveries] = useState<Delivery[]>([])

    const deliveryLoaders = useDeliveryLoaders()

    const load = async () => {
        if (!deliveryOrder) return
        const { loadOrderDeliveries } = deliveryLoaders()
        const loadedDeliveries = await loadOrderDeliveries(deliveryOrder.id)
        setDeliveries(loadedDeliveries)
    }

    useEffect(() => {
        load()
    }, [deliveryOrder?.id])
    
    return (
        <DownloadDeliveryNotesModal
            deliveries={deliveries}
            deliveryOrders={toList(deliveryOrder)}
        />
    )
}
